import { render } from "./MenuItem.vue?vue&type=template&id=3afb5cbc"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/layout/menu/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3afb5cbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3afb5cbc', __exports__)) {
    console.log('reload')
    api.reload('3afb5cbc', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=3afb5cbc", () => {
    console.log('re-render')
    api.rerender('3afb5cbc', render)
  })

}


export default __exports__